@if ((currentView$ | async); as currentView) {
  <filter-view-layout
    id="folders-view-container"
    #foldersContainer>
    <div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
      <div [formGroup]="form">
        <div class="filter-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
            <mat-select
              formControlName="filterBy"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of filterByOptions; track option) {
                <mat-option
                  [value]="option">
                  {{ filterByTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
        <div class="sort-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_sort-by' | translate }}</mat-label>
            <mat-select
              formControlName="sortBy"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of sortByOptions; track option) {
                <mat-option
                  [value]="option">
                  {{ sortByTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
        @if ((instructors$ | async); as instructors) {
          <div class="account-container">
            <mat-form-field goSelect>
              <mat-label>{{ 'common_account' | translate }}</mat-label>
              <mat-select
                formControlName="instructorId"
                disableOptionCentering
                panelClass="offsetPanel">
                @for (instructor of instructors | alphabeticalByKey:'first_name'; track instructor) {
                  <mat-option
                    [value]="instructor.user_id">
                    {{ instructor.first_name + ' ' + instructor.last_name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          </div>
        }
      </div>
    </div>
    <div class="filter-option" filter-view-options-bar [hidden]="dataSourceZeroState.hasZeroState">
      <toggle-grid-list-view></toggle-grid-list-view>
    </div>
    @if (!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading) {
      <div class="filter-content"
        filter-view-content
        (contextmenu)="openMenu($event)">
        @if (hasFolders$ | async) {
          @if (currentView === views.LIST) {
            <folders-table-view (goToFolder)="goToFolder($event)"></folders-table-view>
          } @else {
            <folders-grid-view (goToFolder)="goToFolder($event)"></folders-grid-view>
          }
        } @else {
          <folders-zero-state
            (createFolder)="openCreateCoursePanel()"
            (openInvite)="openInviteModal()"
            (filterByChange)="onZeroStateFilterChange($event)"
            [canInvite]="canInvite()"
          ></folders-zero-state>
        }
        @if (canInvite() || canCreateCourse()) {
          <menu>
            <org-context-menu
              [canInvite]="canInvite()"
              [canCreateCourse]="canCreateCourse()"
              (onInvite)="openInviteModal()"
            (onCreateCourse)="openCreateCoursePanel()"></org-context-menu>
          </menu>
        }
      </div>
    }
    <!-- Datasource zero state -->
    <div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
      <data-source-zero-state [dataSource]="folderListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
    </div>
    <div class="filter-action" filter-view-action-bar [hidden]="dataSourceZeroState.hasZeroState">
      @if (hasFolders$ | async) {
        <div class="btn-wrapper">
          @if (canCreateCourse()) {
            <button class="create-course-btn primary-btn"
              (click)="openCreateCoursePanel()"
              data-cy="create-course"
              [disabled]="isCreating$ | async"
              translate>
              folders_view-create_button
              @if (isCreating$ | async) {
                <i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
              }
            </button>
          }
        </div>
      }
    </div>
  </filter-view-layout>
}
